import coursesCenterImgUrl from '../../../images/portfolio/web-images/bootstrap/courses-center.jpg';
import appLandingPageImgUrl from '../../../images/portfolio/web-images/bootstrap/app-landing-page.jpg';
import knowledgeBankImgUrl from '../../../images/portfolio/web-images/bootstrap/knowledge-bank.jpg';
import smallBusinessImgUrl from '../../../images/portfolio/web-images/bootstrap/small-business.jpg';
import surveyImgUrl from '../../../images/portfolio/web-images/bootstrap/survey.jpg';
import portfolioImgUrl from '../../../images/portfolio/web-images/bootstrap/portfolio.jpg';
import cvImgUrl from '../../../images/portfolio/web-images/bootstrap/cv.jpg';

const bootstrapTemplateList = [
  {
    imgUrl: coursesCenterImgUrl,
    title: 'Courses Center',
    githubUrl: 'https://github.com/amrsaadabdallah/my-courses-center',
    infoUrl: 'https://github.com/amrsaadabdallah/courses-center',
    liveUrl: 'https://amrsaadabdallah.github.io/courses-center',
    type: 'large',
  },
  {
    imgUrl: appLandingPageImgUrl,
    title: 'App Landing Page',
    githubUrl: 'https://github.com/amrsaadabdallah/my-app-landing-page',
    infoUrl: 'https://github.com/amrsaadabdallah/app-landing-page',
    liveUrl: 'https://amrsaadabdallah.github.io/app-landing-page',
    type: 'large',
  },
  {
    imgUrl: knowledgeBankImgUrl,
    title: 'Knowledge Bank',
    githubUrl: 'https://github.com/amrsaadabdallah/my-knowledge-bank',
    infoUrl: 'https://github.com/amrsaadabdallah/knowledge-bank',
    liveUrl: 'https://amrsaadabdallah.github.io/knowledge-bank',
    type: 'large',
  },
  {
    imgUrl: smallBusinessImgUrl,
    title: 'Small Business',
    githubUrl: 'https://github.com/amrsaadabdallah/my-small-business',
    infoUrl: 'https://github.com/amrsaadabdallah/small-business',
    liveUrl: 'https://amrsaadabdallah.github.io/small-business',
    type: 'large',
  },
  {
    imgUrl: surveyImgUrl,
    title: 'Survey',
    githubUrl: 'https://github.com/amrsaadabdallah/my-survey',
    infoUrl: 'https://github.com/amrsaadabdallah/survey',
    liveUrl: 'https://amrsaadabdallah.github.io/survey',
    type: 'small',
  },
  {
    imgUrl: portfolioImgUrl,
    title: 'Portfolio',
    githubUrl: 'https://github.com/amrsaadabdallah/my-portfolio',
    infoUrl: 'https://github.com/amrsaadabdallah/portfolio',
    liveUrl: 'https://amrsaadabdallah.github.io/portfolio',
    type: 'large',
  },
  {
    imgUrl: cvImgUrl,
    title: 'CV',
    githubUrl: 'https://github.com/amrsaadabdallah/my-cv',
    infoUrl: 'https://github.com/amrsaadabdallah/cv',
    liveUrl: 'https://amrsaadabdallah.github.io/cv',
    type: 'large',
  },
];

export default bootstrapTemplateList;
